import { Component, OnInit, Input, ViewChild, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { UserSessionService } from '../shared';
import { MailsBox, MailsBoxService } from './mails-box.service';
import { takeUntil, mergeMap } from 'rxjs/operators';
import { DocManagementTrans, FileToUpload } from '../docu-manage-new/image-upload-new';

const MAX_SIZE: number = 11048576;

@Component({
    selector: 'app-mails-box',
    templateUrl: './mails-box.component.html',
    styleUrls: ['./mails-box.component.css']
})
export class MailsBoxComponent implements OnInit, OnDestroy {
    private ngUnsubscribe: Subject<void> = new Subject<void>();
    @Input() parentUIKey: string;
    @Input() _UIKey: string;
    @ViewChild('popup') popup: any;


    MailsBox: MailsBox[] = [];
    subject: string = '';
    reciverEmpId: number;
    senderEmpId: number = JSON.parse(sessionStorage.getItem('currentUser')).userID;
    mailsBox: MailsBox = <MailsBox>{};
    public MailsBoxs: MailsBox = <MailsBox>{};

    composeMessageForm: UntypedFormGroup
    visitSerial: any;

    chartsRefrech: boolean = false;
    @ViewChild('btnCtrl1') btnCtrl1: any;

    constructor(
        public translate: TranslateService,
        private _fb: UntypedFormBuilder,
        private _MailsBoxService: MailsBoxService,
        private _userSessionService: UserSessionService) { }

    ngOnInit() {
        this.createForm();
    }

    ngAfterViewInit() {
        this._userSessionService.setBtnCtrl(this.btnCtrl1);
    };

    ngOnDestroy() {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }
    createForm() {
        this.composeMessageForm = this._fb.group({
            serial: [null],
            reciverEmpId: [''],
            selectAll: [false],
            reciverGroupId: [''],
            reciverGroupIdArray: [''],
            reciverSecLoginIdArray: [''],
            reciverSecLoginId: [''],

            subject: ['', Validators.required],
            message: ['', Validators.required],


        });
    }

    onClicked(e: number): void {
        switch (e) {
            case 6623:
                this.sendMessage();
                break;
        }
    }

    sendMessage() {
        if (this.composeMessageForm.invalid)
            return;
        this.composeMessageForm.value.selectAll = this.composeMessageForm.value.selectAll ? 1 : 0
        this.MailsBoxs = this.composeMessageForm.value;

        if (this.MailsBoxs.serial == undefined || !this.MailsBoxs.serial) {
            this.MailsBoxs.serial = -1
        }
        this._MailsBoxService.postMailBox(this.MailsBoxs)
            .pipe(
                //mergeMap(data => this.saveFileData(data)),
                takeUntil(this.ngUnsubscribe))
            .subscribe((res: any) => {
                if (res && res.returnFlag) {
                    if (res.data && res.data.length) this.savedId = res.data[0].serial;
                    this.uploadFile();
                    this.composeMessageForm.reset()
                }
            });
    }
    savedId: number


    /// go to print
    openInNewWindow() {
        this._userSessionService.setSessionKey("GoToTabOfSerial", 1013)
    }

    saveFileData(file: FileToUpload) {
        let docManagementTrans = <DocManagementTrans>{};
        docManagementTrans.base64 = file.fileAsBase64;//this._fileBase64Copy.split('base64,')[1];
        docManagementTrans.tableRowId = this.savedId;
        docManagementTrans.documentLookupCode = 65;
        docManagementTrans.docManagementSerial = 65;
        docManagementTrans.docFolderLookupSerial = 1;
        docManagementTrans.docName = file.fileName;
        docManagementTrans.serial = -1;
        docManagementTrans.fileToUpload = file;
        this._MailsBoxService.FileToUploadPost(docManagementTrans).then(res => {
            if (res && res.returnFlag) {
                this.lengthForSave -= 1;
                if (this.lengthForSave == 0) {
                    this.fileName = ''
                    this.composeMessageForm.reset();
                    this._userSessionService.closeModalKey('MailsBoxComponent', {})
                }
                this.fileName = ''
                this.filesNames = ''

            }
        });
    }

    ////////// NEW UPLOAD SECTION
    theFiles: any[] = [];
    messages: any[] = [];
    lengthForSave: number;

    uploadFile(): void {
        for (let index = 0; index < this.theFiles.length; index++) {
            this.readAndUploadFile(this.theFiles[index]);
        }
    }

    fileName: string
    onFileChange(event) {
        this.theFiles = [];

        // Any file(s) selected from the input?
        if (event.target.files && event.target.files.length > 0) {
            this.lengthForSave = event.target.files.length;
            for (let index = 0; index < event.target.files.length; index++) {
                let file = event.target.files[index];
                // Don't allow file sizes over 11MB
                if (file.size < MAX_SIZE) {
                    // Add file to list of files
                    this.theFiles.push(file);
                }
                else {
                    this.messages.push("File: " + file.name + " is too large to upload.");
                }
            }
            this.filesNames = this.theFiles.map(el => el.name).toString();
        }
    }

    // file: FileToUpload;
    filesNames: string = 'Attachments';
    private readAndUploadFile(theFile: any) {
        let file = new FileToUpload();

        // Set File Information
        file.fileName = theFile.name;
        file.fileSize = theFile.size;
        file.fileType = theFile.type;
        file.lastModifiedTime = theFile.lastModified;
        file.lastModifiedDate = theFile.lastModifiedDate;

        // Use FileReader() object to get file to upload
        // NOTE: FileReader only works with newer browsers
        let reader = new FileReader();

        // Setup onload event for reader
        reader.onload = () => {
            // Store base64 encoded representation of file
            file.fileAsBase64 = reader.result.toString();

            // save to server
            ////here call save method\\\\
            this.saveFileData(file);
        }

        // Read the file
        reader.readAsDataURL(theFile);
    }
}
